const initialState = {
  resultsProductCategoriesList: [],
  resultsProductCategory: {},
  resultsProductCategoryAdd: {},
  resultsProductCategoryEdit: {},
  resultsProductCategoryDelete: {},
  loading: false,
};

const reducer = (state = initialState, action) => {
  const newState = { ...state };

  switch (action.type) {
    case "GET_LIST_PRODUCT_CATEGORY":
    case "GET_PRODUCT_CATEGORY":
    case "ADD_PRODUCT_CATEGORY":
    case "EDIT_PRODUCT_CATEGORY":
    case "DELETE_PRODUCT_CATEGORY":
      newState.loading = true;
      break;
    case "LIST_PRODUCT_CATEGORY_RESPONSE_GET":
      newState.resultsProductCategoriesList = action.value;
      newState.loading = false;
      break;
    case "PRODUCT_CATEGORY_RESPONSE_GET":
      newState.resultsProductCategory = action.value;
      newState.loading = false;
      break;
    case "PRODUCT_CATEGORY_RESPONSE_ADD":
      newState.resultsProductCategoryAdd = action.value;
      newState.loading = false;
      break;
    case "PRODUCT_CATEGORY_RESPONSE_DELETE":
      newState.resultsProductCategoryDelete = action.value;
      newState.loading = false;
      break;
    case "PRODUCT_CATEGORY_RESPONSE_EDIT":
      newState.resultsProductCategoryEdit = action.value;
      newState.loading = false;
      break;
    case "RESET_PRODUCT_CATEGORY_RESPONSES":
      newState.resultsProductCategoriesList = [];
      newState.resultsProductCategoryAdd = {};
      newState.resultsProductCategoryEdit = {};
      newState.resultsProductCategoryDelete = {};
      break;
    default:
      break;
  }
  return newState;
};

export default reducer;
